import Grid from '@anwb/poncho/components/grid';

import { getCurrentStepNumber } from '../../../../utils/navigation';
import { RequestFlowTitle } from '../../RequestFlow.styled';
import { usePageTitle } from '../../hooks/usePageTitle';

import { ServicesHealthErrorNotification } from './ServicesHealthErrorNotification';

export const ServicesHealthError = () => {
	const currentStepNumber = getCurrentStepNumber();
	const isAtThankYouStep = currentStepNumber === 4;
	const pageTitle = usePageTitle(isAtThankYouStep);

	return (
		<Grid justify="center" constrainedWidth>
			<Grid.Item>
				<RequestFlowTitle variant="page-title" data-test="request-flow-title">
					{pageTitle}
				</RequestFlowTitle>
			</Grid.Item>
			<Grid.Item inline fullWidth>
				<ServicesHealthErrorNotification />
			</Grid.Item>
			<Grid.Aside>
				<div />
			</Grid.Aside>
		</Grid>
	);
};
